// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PaperclipBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m26.56 17.061-10.258 10.25a7.5 7.5 0 1 1-10.606-10.61l12.27-12.236a5 5 0 0 1 7.07 7.074l-.021.02L13.04 23.086a1.5 1.5 0 1 1-2.08-2.162L22.924 9.409a2 2 0 1 0-2.838-2.82L7.816 18.82a4.501 4.501 0 0 0 6.366 6.364l10.258-10.25a1.503 1.503 0 0 1 2.125 2.125l-.005.001Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
